import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {

  getCrashCourseList ({state, commit}) {
    return new Promise ((resolve, reject) => {
      axios.get('crash-course/get-course-list')
      .then(response => {
        commit('setCrashCourseList', response.data)
      })
    })
  },
  getStudent ({commit}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('crash-course/get-student', data)
      .then(response => {
        resolve(response.data)
        //commit('setCrashCoursePaymentList', response.data)
      })
    })
  },
  getUserPaymentList ({commit}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('crash-course/get-user-payment-list', data)
      .then(response => {
        commit('setCrashCoursePaymentList', response.data)
      })
    })
  },
  createStudentPayment ({commit}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('save-user-payment', data)
      .then(response => {
        resolve(response.data)
      })
    })
  },

  updateUserPayment ({commit}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('crash-course/update-user-payment', data)
      .then(response => {
        resolve(response.data)
      })
    })
  }

}
